import { combineReducers } from "redux";
import companysearch from "./companysearch";

const rootreducer = combineReducers({
  companysearch
});

export default rootreducer;